module.exports = __webpack_public_path__ + "img/chinesecompany219.170d28ac.png";